import {
  Box,
  Center,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

function Texts({ texts }) {
  return (
    <Text
      p={{ base: 4, md: 6, xl: 6 }}
      fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
    >
      <Lang text={texts} />
    </Text>
  );
}

export default function AIprofTerms() {
  return (
    <>
      <LineSection />

      <Center>
        <Box
          w={{ base: "xl", md: "full", xl: "6xl" }}
          py={{ base: 20, md: 40 }}
          color={"white"}
        >

          <SectionHeading
            title="Terms and Conditions specific for"
            span="AI-Prof"
          />
          <Box
            mt={{ base: 10, md: 20 }}
          >

            <Texts texts="Must be an officially enrolled student in a university program in data science, data engineering, artificial intelligence or similar. The student must belong to a vulnerable population and must be from a low-income country." />
            <Texts texts="AppOX may require documents and evidence that demonstrate economics difficulties and/or academics scores." />

          </Box>
        </Box>
      </Center>
    </>
  );
}